import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DatePopup = ({ item, onClose, onDateChange }) => {
  const [startDate, setStartDate] = React.useState(item.startDate || null);
  const [endDate, setEndDate] = React.useState(item.endDate || null);

  const handleSave = () => {
    onDateChange(startDate, endDate);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        <button
          onClick={onClose}
          className="absolute right-2 top-2 text-gray-600 hover:text-gray-800 focus:outline-none"
        >
          &times;
        </button>
        <h6 className="mb-4 font-semibold">Select Dates for {item.name}</h6>
        <div className="mb-4">
          <div className="flex space-x-4">
            <div className="flex-1">
              <label className="block text-gray-700">Start Date:</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat="yyyy/MM/dd"
                placeholderText="Select start date"
                className="w-full rounded border p-2"
              />
            </div>
            <div className="flex-1">
              <label className="block text-gray-700">End Date:</label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                dateFormat="yyyy/MM/dd"
                placeholderText="Select end date"
                className="w-full rounded border p-2"
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            onClick={handleSave}
            className="rounded-md bg-blue-900 px-4 py-2 text-white"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default DatePopup;
